import { render, staticRenderFns } from "./SearchResultSection.vue?vue&type=template&id=b8047a76&scoped=true"
import script from "./SearchResultSection.vue?vue&type=script&lang=js"
export * from "./SearchResultSection.vue?vue&type=script&lang=js"
import style0 from "./SearchResultSection.vue?vue&type=style&index=0&id=b8047a76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8047a76",
  null
  
)

export default component.exports